import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import ListClientes from "./pages/list/ListClientes";
import ListTiendasCliente from "./pages/list/ListTiendasCliente";
import Single from "./pages/single/Single";
import Details from "./pages/details/Details";
import Documents from "./pages/documents/Documents";
import Trash from "./pages/documents/DeletedDocuments";
import Servicio from "./pages/servicio/Servicio.jsx";
import UpdateServicio from "./pages/servicio/UpdateServicio.jsx";
import New from "./pages/new/New";
import Update from "./pages/update/Update";
import UpdateCliente from "./pages/update/UpdateCliente";
import NewCliente from "./pages/new/NewCliente";
import NewClienteTienda from "./pages/new/NewClienteTienda";
import UpdateTienda from "./pages/update/UpdateTienda";
import BuzonAnonimo from "./pages/buzonAnonimo/BuzonAnonimo.jsx";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { clientesInputs, productInputs, userInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { SidebarStateProvider } from "./components/sidebar/SidebarStateProvider.js"
import { AuthContext } from "./context/AuthContext";
import { AuthContextProvider } from "./context/AuthContext";
import PrivacyPolicy from './components//infoBox/PrivacyPolicy';
import Forms from "./pages/list/Forms";
import FormsTable from "./pages/list/FormsTable";
import FormsUpdate from "./pages/update/UpdateForm";
import PdfDesigns from "./pages/list/PdfDesigns";
import PdfDesignEditor from "./components/forms/PdfDesignEditor";
import NotificationsForm from "./pages/list/NotificationsForm";
import ProfileContainer from "./pages/user/ProfileContainer.js";
import ConfigContainer from "./pages/user/ConfigContainer.js";
import EditAdminContainer from "./pages/user/EditAdminContainer.js";
import AddUserContainer from "./pages/user/AddUserContainer.js";
import DataCuadrantes from "./pages/cuadrante/Cuadrante.jsx"
import CuadranteServicio from "./pages/cuadrante/CuadranteServicio.jsx";
import CuadranteVigilante from "./pages/cuadrante/CuadranteVigilantes.jsx";

import CompanyContainer from "./pages/user/CompanyContainer.js";
import Jornadas from "./pages/list/Jornadas.jsx";
// import TestConnection from "./components/cuadrantes/config/TestConnection.jsx";
import AddClientUser from "./pages/user/AddUserClientContainer.js";
import ClientPortalConfig from "./pages/user/ClientPortalConfigContainer.js";
import ControlRondas from "./pages/controlRondas/ControlRondas";
import { LicenseInfo } from '@mui/x-license-pro';
import DashboardNotifications from "./pages/internalNotifications/DashboardNotifications.jsx";
import ChatBot from "./components/ChatBot/ChatBot.jsx";
import DatasetsPage from './pages/datasets/DatasetsPage';
import Storage from './pages/storage/Storage';
import Logs from './pages/logs/Logs';
import CalendarPage from './pages/calendar/Calendar';
import Licenses from './pages/licenses/Licenses';
import LogDetail from './pages/logs/LogDetail';
import GestionEquiposColaborativos from './components/equipos/GestionEquiposColaborativos';
import EquiposColaborativos from './pages/equiposColaborativos/EquiposColaborativos';

/**
 * Componente principal de la aplicación.
 */
function App() {
  const { currentUser, adminData } = useContext(AuthContext);
  // Introduce tu clave de licencia aquí
  const licenseKey = 'f106466088bc564c25f0d3b3f23e9571Tz0xMjE5MTksRT0xNzk3MDMzNTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y';
  LicenseInfo.setLicenseKey(licenseKey);
  /**
 * Componente de ruta protegida que requiere autenticación.
 * Redirige al usuario a la página de inicio de sesión si no está autenticado.
 *
 * @param {Object} children - Componente anidado dentro de RequireAuth.
 * @returns {JSX.Element} - Componente RequireAuth.
 */
  const RequireAuth = ({ children, checkRole }) => {
    const tieneAccesoPorRol = () => {
      if (!checkRole || !adminData || !adminData.tipoUsuario) return true;
      return adminData.tipoUsuario.some(role => checkRole.includes(role));
    };

    return currentUser && tieneAccesoPorRol() ? children : <Navigate to="/login" />;
  };

  return (
    <div className="app">
      <BrowserRouter>
        <AuthContextProvider>
          <SidebarStateProvider>
            {/* <TestConnection /> */}
            <Routes>
              <Route path="/">
                <Route path="login" element={<Login />} />
                <Route path="/servicio" element={<Servicio />} />
                <Route path="/UpdateServicio" element={<UpdateServicio />} />
                <Route path="/company"
                  index
                  element={
                    <RequireAuth checkRole={['administrativo', 'administrador']}>
                      <CompanyContainer />
                    </RequireAuth>
                  }
                />
                <Route
                  index
                  element={
                    <RequireAuth>
                      <Home />
                    </RequireAuth>
                  }
                />
                <Route path="/profile"
                  index
                  element={
                    <RequireAuth>
                      <ProfileContainer />
                    </RequireAuth>
                  }
                />
                <Route path="/config"
                  index
                  element={
                    <RequireAuth>
                      <ConfigContainer />
                    </RequireAuth>
                  }
                />
                <Route path="/add-User"
                  index
                  element={
                    <RequireAuth>
                      <AddUserContainer />
                    </RequireAuth>
                  }
                />
                <Route path="/add-user-client/:clientId"
                  index
                  element={
                    <RequireAuth>
                      <AddClientUser />
                    </RequireAuth>
                  }
                />
                <Route path="/ClientPortalConfig"
                  index
                  element={
                    <RequireAuth>
                      <ClientPortalConfig />
                    </RequireAuth>
                  }
                />
                <Route path="/edit-admin/:adminId"
                  element={
                    <RequireAuth>
                      <EditAdminContainer />
                    </RequireAuth>
                  }
                />
                <Route path="vigilantes">
                  <Route
                    index
                    element={
                      <RequireAuth>
                        <List />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path=":id"
                    element={
                      <RequireAuth>
                        <Single />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="details/:id"
                    element={
                      <RequireAuth>
                        <Details />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="new"
                    element={
                      <RequireAuth>
                        <New inputs={userInputs} title="Añadir Usuario" />
                      </RequireAuth>
                    }
                  />
                  {/* Modificar esta ruta para usar :id en lugar de :tipVS */}
                  <Route
                    path="update/:id"
                    element={
                      <RequireAuth>
                        <Update inputs={userInputs} title="Actualizar Usuario" />
                      </RequireAuth>
                    }
                  />
                </Route>
                <Route path="control-rondas">
                  <Route
                    index
                    element={
                      <RequireAuth>
                        <ControlRondas />
                      </RequireAuth>
                    }
                  />
                </Route>
                {/* Ruta para el buzón anónimo */}
                <Route path="buzon-anonimo">
                  <Route
                    index
                    element={
                      <RequireAuth>
                        <BuzonAnonimo />
                      </RequireAuth>
                    }
                  />
                </Route>
                <Route path="notificaciones-internas">
                  <Route
                    index
                    element={
                      <RequireAuth>
                        <DashboardNotifications />
                      </RequireAuth>
                    }
                  />
                </Route>
                <Route path="tiendas">
                  <Route
                    path="update/:tiendaId"
                    element={
                      <RequireAuth>
                        <UpdateTienda inputs={productInputs} title="Actualizar servicio" />
                      </RequireAuth>
                    }
                  />
                </Route>
                <Route path="clientes">
                  <Route
                    index
                    element={
                      <RequireAuth>
                        <ListClientes />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/clientes/:clienteId/tiendas/:nombreCliente"
                    element={
                      <RequireAuth>
                        <ListTiendasCliente />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="newCliente"
                    element={
                      <RequireAuth>
                        <NewCliente inputs={clientesInputs} title="Añadir nuevo cliente" />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/clientes/:clienteId/newClienteTienda/:nombreCliente"
                    element={
                      <RequireAuth>
                        <NewClienteTienda inputs={productInputs} title="Añadir nuevo servicio" />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="update/:clienteId"
                    element={
                      <RequireAuth>
                        <UpdateCliente inputs={clientesInputs} title="Actualizar cliente" />
                      </RequireAuth>
                    }
                  />
                </Route>
              </Route>
              <Route path="documentos">
                <Route
                  index
                  element={
                    <RequireAuth checkRole={['administrativo', 'administrador']}>
                      <Documents />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="papelera">
                <Route
                  index
                  element={
                    <RequireAuth checkRole={['administrativo', 'administrador']}>
                      <Trash />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="notificaciones">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <NotificationsForm />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="form-table">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <FormsTable />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="form-creator">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <Forms />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="form-update/:id">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <FormsUpdate />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="pdf-designs">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <PdfDesigns />
                    </RequireAuth>
                  }
                />
                <Route
                  path="new"
                  element={
                    <RequireAuth>
                      <PdfDesignEditor />
                    </RequireAuth>
                  }
                />
                <Route
                  path="edit/:id"
                  element={
                    <RequireAuth>
                      <PdfDesignEditor />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="cuadrantes">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <DataCuadrantes />
                    </RequireAuth>
                  }
                />

                <Route
                  path="edit-servicio/:id"
                  index
                  element={
                    <RequireAuth>
                      <CuadranteServicio />
                    </RequireAuth>
                  }
                />
                <Route
                  path="edit-vigilante/:id"
                  index
                  element={
                    <RequireAuth>
                      <CuadranteVigilante />
                    </RequireAuth>
                  }
                />
              </Route>
              <Route path="jornadas">
                <Route
                  index
                  element={
                    <RequireAuth>
                      <Jornadas />
                    </RequireAuth>
                  }
                />
                <Route
                  path=":vigilanteId"
                  element={
                    <RequireAuth>
                      <Jornadas />
                    </RequireAuth>
                  }
                />
              </Route>
              {/* Ruta para Gestión de Equipos Colaborativos - Kit Digital */}
              <Route path="/equipos-colaborativos" element={
                <RequireAuth>
                  <GestionEquiposColaborativos />
                </RequireAuth>
              } />
              {/* Ruta para Colaboración en Equipos de Trabajo - Kit Digital con datos SCU PRACOM */}
              <Route path="/colaboracion-equipos" element={
                <RequireAuth>
                  <EquiposColaborativos />
                </RequireAuth>
              } />
              <Route path="/datasets" element={
                <RequireAuth>
                  <DatasetsPage />
                </RequireAuth>
              } />
              <Route path="/storage" element={
                <RequireAuth>
                  <Storage />
                </RequireAuth>
              } />
              <Route path="/calendar" element={
                <RequireAuth>
                  <CalendarPage />
                </RequireAuth>
              } />
              <Route path="/licenses" element={
                <RequireAuth checkRole={['administrativo', 'administrador']}>
                  <Licenses />
                </RequireAuth>
              } />
              {/* Rutas públicas para logs - sin autenticación requerida pero con sidebar */}
              <Route path="/logs" element={<Logs />} />
            </Routes>
          </SidebarStateProvider>
        </AuthContextProvider>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* Rutas públicas para logs individuales - sin autenticación ni sidebar */}
          <Route path="/logs/:company/:logId" element={<LogDetail />} />
        </Routes>
        
        {/* ChatBot flotante - aparece en todas las pantallas */}
        <ChatBot />
      </BrowserRouter>
    </div>
  );
}

export default App;